import React, { useState } from "react";
import { Upload, Trash2 } from "lucide-react";
import FileUploadZone from "../components/uploads/FileUploadZone";
import UploadProgressDisplay from "../components/common/UploadProgressDisplay";

const AssetItem = ({ item, projectId, onDelete, onUpload, apiField }) => {
  const [showUpload, setShowUpload] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploadStatus, setUploadStatus] = useState(null);

  const handleUploadFile = async (files) => {
    if (files.length === 0) return;

    const file = files[0];

    try {
      setUploadProgress((prev) => ({
        ...prev,
        [file.name]: "Uploading file...",
      }));

      // const destPath = `projects/${projectId}/${item}/${file.name}`;
      const destPath = `newviewer/master/${projectId}/${file.name}`;

      const formData = new FormData();
      formData.append("file", file);
      formData.append("destPath", destPath);
      formData.append("overwrite", "true");

      const token = localStorage.getItem("token");

      const apiRootOperational =
        process.env.REACT_APP_API_ROOT_OPERATIONAL || "";
      const response = await fetch(
        `${apiRootOperational}/api/files/upload-form`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to upload file");
      }

      setUploadProgress((prev) => ({
        ...prev,
        [file.name]: "Complete",
      }));

      setUploadStatus("success");

      if (onUpload) {
        const baseFilename = file.name.replace(/\.[^/.]+$/, "");
        onUpload(apiField, item, baseFilename);
      }

      setTimeout(() => {
        setUploadProgress({});
        setUploadStatus(null);
        setShowUpload(false);
      }, 2000);
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadProgress((prev) => ({
        ...prev,
        [file.name]: "Failed",
      }));
      setUploadStatus("error");
    }
  };

  return (
    <div className="relative group">
      <div
        className="inline-flex items-center px-3 py-1.5 bg-white border border-gray-200 
          rounded-md text-sm text-gray-700 hover:border-blue-300"
      >
        <span>{item}</span>
        <div className="ml-2 flex">
          <button
            onClick={() => setShowUpload(true)}
            className="p-1 text-gray-500 hover:text-blue-500"
            title="Replace file"
          >
            <Upload size={14} />
          </button>
          <button
            onClick={() => onDelete(apiField, item)}
            className="p-1 text-gray-500 hover:text-red-500"
            title="Delete"
          >
            <Trash2 size={14} />
          </button>
        </div>
      </div>

      {showUpload && (
        <div className="absolute z-10 mt-2 p-4 border border-gray-200 rounded-md bg-white shadow-md w-64">
          <h4 className="text-sm font-medium mb-2">Replace "{item}"</h4>
          <FileUploadZone
            onFilesSelect={handleUploadFile}
            accept=".glb"
            acceptedTypes={["GLB"]}
          />
          <UploadProgressDisplay progress={uploadProgress} />

          {uploadStatus && (
            <div
              className={`mt-2 p-2 ${
                uploadStatus === "success"
                  ? "bg-green-50 border-green-200 text-green-800"
                  : "bg-red-50 border-red-200 text-red-800"
              } border rounded-lg`}
            >
              <p className="text-xs text-center">
                {uploadStatus === "success"
                  ? "File replaced successfully!"
                  : "Error uploading file. Please try again."}
              </p>
            </div>
          )}

          <button
            onClick={() => setShowUpload(false)}
            className="mt-2 px-3 py-1 text-gray-600 text-sm"
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  );
};

export default AssetItem;
